import { render, staticRenderFns } from "./OrderCompletion.vue?vue&type=template&id=e62f32e0&scoped=true&"
import script from "./OrderCompletion.vue?vue&type=script&lang=js&"
export * from "./OrderCompletion.vue?vue&type=script&lang=js&"
import style0 from "./OrderCompletion.vue?vue&type=style&index=0&id=e62f32e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62f32e0",
  null
  
)

export default component.exports